/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { StripeKeyState } from '../state/StripeKeyState'
import StripeKeyEvent from '../../event/StripeKeyEvent'

class StripeKeyStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new StripeKeyState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case StripeKeyEvent.fetchOne:
        return state.mergeModel(payload.stripe_api_key)
      case StripeKeyEvent.onEdit:
        return state.set(payload.name, payload.value)
      case StripeKeyEvent.onClear:
        return state.clear()
      default:
        return state
    }
  }
}

export default new StripeKeyStore()
